export default __webpack_public_path__ + "static/poster-5e93229685c18b9b77831c865006f4e2.png";